/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AIP } from './AIP';
import {
    AIPFromJSON,
    AIPFromJSONTyped,
    AIPToJSON,
} from './AIP';
import type { DIP } from './DIP';
import {
    DIPFromJSON,
    DIPFromJSONTyped,
    DIPToJSON,
} from './DIP';
import type { SIP } from './SIP';
import {
    SIPFromJSON,
    SIPFromJSONTyped,
    SIPToJSON,
} from './SIP';

/**
 * Transfer describes a set of files and metadata submitted by a GSA to SDPS for processing.
 * @export
 * @interface Transfer
 */
export interface Transfer {
    /**
     * AIP's created from the Transfers' SIP's.
     * @type {Array<AIP>}
     * @memberof Transfer
     */
    aips?: Array<AIP>;
    /**
     * Batch that contained the transfer.
     * @type {number}
     * @memberof Transfer
     */
    batchId?: number;
    /**
     * Batch number
     * @type {string}
     * @memberof Transfer
     */
    batchNumber?: string;
    /**
     * Total number of critical errors for this transfer.
     * @type {number}
     * @memberof Transfer
     */
    criticalErrorCount?: number;
    /**
     * Department code.
     * @type {string}
     * @memberof Transfer
     */
    department: string;
    /**
     * Agency deposit completed datetime.
     * @type {Date}
     * @memberof Transfer
     */
    depositedAt?: Date;
    /**
     * DIP's created from the Transfers' SIP's.
     * @type {Array<DIP>}
     * @memberof Transfer
     */
    dips?: Array<DIP>;
    /**
     * Total number of Files in transfer.
     * @type {number}
     * @memberof Transfer
     */
    fileCount?: number;
    /**
     * Highest security grade of any content in the transfer.
     * @type {string}
     * @memberof Transfer
     */
    highestSecurityGrading?: string;
    /**
     * Highest sensisivity classification of any content in the transfer.
     * @type {string}
     * @memberof Transfer
     */
    highestSensitivityClassification?: string;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof Transfer
     */
    id: string;
    /**
     * Name of the transfer.
     * @type {string}
     * @memberof Transfer
     */
    name?: string;
    /**
     * Total number of non-critical errors for this transfer.
     * @type {number}
     * @memberof Transfer
     */
    noncriticalErrorCount?: number;
    /**
     * Batch note.
     * @type {string}
     * @memberof Transfer
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof Transfer
     */
    noteCreatedAt?: Date;
    /**
     * Creator of note.
     * @type {string}
     * @memberof Transfer
     */
    noteCreatedBy?: string;
    /**
     * SDPS processing completed datetime.
     * @type {Date}
     * @memberof Transfer
     */
    processingCompletedAt?: Date;
    /**
     * SDPS processing started datetime.
     * @type {Date}
     * @memberof Transfer
     */
    processingStartedAt?: Date;
    /**
     * Total number of SIPs in transfer.
     * @type {number}
     * @memberof Transfer
     */
    sipCount?: number;
    /**
     * SIP's created from Transfer.
     * @type {Array<SIP>}
     * @memberof Transfer
     */
    sips?: Array<SIP>;
    /**
     * Current status of the transfer.
     * @type {string}
     * @memberof Transfer
     */
    status: TransferStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Transfer
     */
    statusUpdatedAt: Date;
    /**
     * Transfer Structure type.
     * @type {string}
     * @memberof Transfer
     */
    structureType?: TransferStructureTypeEnum;
    /**
     * Total size of transfer in bytes.
     * @type {number}
     * @memberof Transfer
     */
    totalTransferSize?: number;
    /**
     * Transfer date
     * @type {Date}
     * @memberof Transfer
     */
    transferDate?: Date;
    /**
     * Name of the Transferring Agency.
     * @type {string}
     * @memberof Transfer
     */
    transferringAgency?: string;
    /**
     * Total number of warnings for this transfer.
     * @type {number}
     * @memberof Transfer
     */
    warningCount?: number;
    /**
     * Identifier of workflow selected for batch processing.
     * @type {string}
     * @memberof Transfer
     */
    workflowId?: string;
}


/**
 * @export
 */
export const TransferStatusEnum = {
    Received: 'Received',
    Failed: 'Failed',
    PreProcessing: 'Pre-Processing',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PackagesCreated: 'Packages Created',
    PackagesSentToStorage: 'Packages Sent to Storage',
    Stored: 'Stored',
    ReportCreated: 'Report Created',
    SipCreationFailed: 'SIP Creation Failed'
} as const;
export type TransferStatusEnum = typeof TransferStatusEnum[keyof typeof TransferStatusEnum];

/**
 * @export
 */
export const TransferStructureTypeEnum = {
    EasA: 'EAS A',
    EasB: 'EAS B',
    EasD1: 'EAS D-1',
    Bag: 'Bag'
} as const;
export type TransferStructureTypeEnum = typeof TransferStructureTypeEnum[keyof typeof TransferStructureTypeEnum];


/**
 * Check if a given object implements the Transfer interface.
 */
export function instanceOfTransfer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function TransferFromJSON(json: any): Transfer {
    return TransferFromJSONTyped(json, false);
}

export function TransferFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transfer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aips': !exists(json, 'aips') ? undefined : ((json['aips'] as Array<any>).map(AIPFromJSON)),
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'batchNumber': !exists(json, 'batch_number') ? undefined : json['batch_number'],
        'criticalErrorCount': !exists(json, 'critical_error_count') ? undefined : json['critical_error_count'],
        'department': json['department'],
        'depositedAt': !exists(json, 'deposited_at') ? undefined : (new Date(json['deposited_at'])),
        'dips': !exists(json, 'dips') ? undefined : ((json['dips'] as Array<any>).map(DIPFromJSON)),
        'fileCount': !exists(json, 'file_count') ? undefined : json['file_count'],
        'highestSecurityGrading': !exists(json, 'highest_security_grading') ? undefined : json['highest_security_grading'],
        'highestSensitivityClassification': !exists(json, 'highest_sensitivity_classification') ? undefined : json['highest_sensitivity_classification'],
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noncriticalErrorCount': !exists(json, 'noncritical_error_count') ? undefined : json['noncritical_error_count'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'noteCreatedAt': !exists(json, 'note_created_at') ? undefined : (new Date(json['note_created_at'])),
        'noteCreatedBy': !exists(json, 'note_created_by') ? undefined : json['note_created_by'],
        'processingCompletedAt': !exists(json, 'processing_completed_at') ? undefined : (new Date(json['processing_completed_at'])),
        'processingStartedAt': !exists(json, 'processing_started_at') ? undefined : (new Date(json['processing_started_at'])),
        'sipCount': !exists(json, 'sip_count') ? undefined : json['sip_count'],
        'sips': !exists(json, 'sips') ? undefined : ((json['sips'] as Array<any>).map(SIPFromJSON)),
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'structureType': !exists(json, 'structure_type') ? undefined : json['structure_type'],
        'totalTransferSize': !exists(json, 'total_transfer_size') ? undefined : json['total_transfer_size'],
        'transferDate': !exists(json, 'transfer_date') ? undefined : (new Date(json['transfer_date'])),
        'transferringAgency': !exists(json, 'transferring_agency') ? undefined : json['transferring_agency'],
        'warningCount': !exists(json, 'warning_count') ? undefined : json['warning_count'],
        'workflowId': !exists(json, 'workflow_id') ? undefined : json['workflow_id'],
    };
}

export function TransferToJSON(value?: Transfer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aips': value.aips === undefined ? undefined : ((value.aips as Array<any>).map(AIPToJSON)),
        'batch_id': value.batchId,
        'batch_number': value.batchNumber,
        'critical_error_count': value.criticalErrorCount,
        'department': value.department,
        'deposited_at': value.depositedAt === undefined ? undefined : (value.depositedAt.toISOString()),
        'dips': value.dips === undefined ? undefined : ((value.dips as Array<any>).map(DIPToJSON)),
        'file_count': value.fileCount,
        'highest_security_grading': value.highestSecurityGrading,
        'highest_sensitivity_classification': value.highestSensitivityClassification,
        'id': value.id,
        'name': value.name,
        'noncritical_error_count': value.noncriticalErrorCount,
        'note': value.note,
        'note_created_at': value.noteCreatedAt === undefined ? undefined : (value.noteCreatedAt.toISOString()),
        'note_created_by': value.noteCreatedBy,
        'processing_completed_at': value.processingCompletedAt === undefined ? undefined : (value.processingCompletedAt.toISOString()),
        'processing_started_at': value.processingStartedAt === undefined ? undefined : (value.processingStartedAt.toISOString()),
        'sip_count': value.sipCount,
        'sips': value.sips === undefined ? undefined : ((value.sips as Array<any>).map(SIPToJSON)),
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'structure_type': value.structureType,
        'total_transfer_size': value.totalTransferSize,
        'transfer_date': value.transferDate === undefined ? undefined : (value.transferDate.toISOString().substr(0,10)),
        'transferring_agency': value.transferringAgency,
        'warning_count': value.warningCount,
        'workflow_id': value.workflowId,
    };
}

